import {pickBy} from 'lodash/fp';

//  tslint:disable-next-line: strict-type-predicates
export const removeNullFields = (obj: object): object => pickBy((x) => x !== null, obj);
